import { render, staticRenderFns } from "./LegacyOrderSummaryList.vue?vue&type=template&id=4b4df2dc"
import script from "./LegacyOrderSummaryList.vue?vue&type=script&lang=js"
export * from "./LegacyOrderSummaryList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports